import Snappy from '../snappy/snappy';
import $ from 'jquery';

Snappy.Component.ServerValidation = class ServerValidation extends Snappy.BaseComponent {
  static get tagName() {
    return 'fa-form-validation';
  }

  constructor(element) {
    super(element);
  }

  setVars() {
    this.errorClass = 'fa-input-field--error';
    this.messageClass = 'fa-input-field__error-message';
  }

  setEventListeners() {
    this.$element.on('submit', this.validateForm.bind(this));
  }

  validateForm(event) {
    event.preventDefault();

    /* TEMP - expected JSON format from server
    {
        "success": false,
        "fields": [
          {
            "success": false,
            "element": "email-field",
            "message": "Please enter an email address"
          },
          {
            "success": true,
            "element": "text-field"
          },
          {
            "success": false,
            "element": "dropdown-field",
            "message": "Please choose an option"
          }
        ]
    }
    */
    $.ajax({
      "url": this.$element.attr('action'),
      "method": this.$element.attr('method'),
      "data": this.$element.serialize()
    })
      .always(this.handleValidationResponse.bind(this));
  }

  handleValidationResponse(response) {
    if (!response.success) {
      $.each(response.fields, (i, field) => {
        if (!field.success) {
          this.showValidationError(field);
        } else {
          this.removeValidationError(field);
        }
      });
    } else {
      this.$element.off().submit();
    }
  }

  showValidationError(field) {
    const $element = this.$element.find(`[name=${field.element}]`);

    $element
      .addClass(this.errorClass)
      .parent()
      .addClass(this.errorClass)
      .find(`.${this.messageClass}`).text(field.message);
  }

  removeValidationError(field) {
    const $element = this.$element.find(`[name=${field.element}]`);

    $element
      .removeClass(this.errorClass)
      .parent()
      .removeClass(this.errorClass)
      .find(`.${this.messageClass}`).text('');
  }

  render() {
    this.setVars();
    this.setEventListeners();
  }
}



// WEBPACK FOOTER //
// ./libs/validation/serverValidation.js